import { VariablesToTest } from "./variablesToTest";
import {
  DEFAULT_SCRATCH_DEDUCTION,
  getScratchBlockId,
  setScratch,
} from "./scratch";

export const TestsElements = ({
  itemResult,
  saveDataRef,
  setBtnLoading,
  callGetCombine,
}) => {
  const scratchBlockId = getScratchBlockId(itemResult);

  return (
    <div className="border border-blue-700 rounded px-4 py-3 items-center mb-3">
      <div className="font-normal">
        <b className="text-[#5057FF]">{itemResult?.attempt}: </b>
        {itemResult?.name}
      </div>

      {itemResult?.unit === "seconds" && (
        <div className="flex items-center mt-2 ml-3">
          <label className="flex items-center text-gray-600">
            <input
              type="checkbox"
              id={`scratch-${scratchBlockId}`}
              className="mr-2"
              onChange={(e) =>
                setScratch(
                  scratchBlockId,
                  e.target.checked ? DEFAULT_SCRATCH_DEDUCTION : null,
                )
              }
            />
            Scratch
          </label>
          <input
            type="number"
            id={`scratchDeduction-${scratchBlockId}`}
            className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5 disabled:bg-gray-200 disabled:cursor-not-allowed"
            placeholder="0.000"
            min={0}
            step="0.001"
            disabled
            onWheel={(e) => e.currentTarget.blur()}
          />
          <span className="ml-2 text-gray-600">sec</span>
        </div>
      )}

      {itemResult?.test?.map((itemTest, indexTest) => {
        const backendDetail = itemResult?.athleteTestDetails?.find(
          (detail) =>
            detail.fieldId === itemTest.fieldId &&
            detail.attemptNumber === itemResult.attempt,
        );

        return (
          <VariablesToTest
            key={indexTest}
            itemTest={{
              ...itemTest,
              physicalTestName: itemResult?.name,
              unit: itemResult?.unit,

              subFieldValues: {
                topSpeed: backendDetail?.auxiliary1 ?? 0,
              },
            }}
            saveDataRef={saveDataRef}
            setBtnLoading={setBtnLoading}
            callGetCombine={callGetCombine}
          />
        );
      })}
    </div>
  );
};
